<pfx-panel
  title="Aktive Helfer ({{ caregiverDocumentationCountData()?.length }})"
  [toggleable]="true"
  [scrollableContent]="true"
>
  @if (isLoading()) {
    <pfx-skeleton-loading></pfx-skeleton-loading>
    <pfx-skeleton-loading></pfx-skeleton-loading>
    <pfx-skeleton-loading></pfx-skeleton-loading>
  } @else {
    <ul class="p-0 m-0 list-none border-0">
      @for (caregiverData of caregiverDocumentationCountData(); track caregiverData.caregiver._id) {
        <li class="flex items-center">
          <div class="flex items-center">
            <div class="ml-2">
              <div>
                <a
                  [routerLink]="['/business-partner-center', caregiverData.caregiver._id]"
                  class="p-0 font-bold p-button-link"
                  >{{ caregiverData.caregiver.mainAddress.firstname }}
                  {{ caregiverData.caregiver.mainAddress.lastname }}</a
                >
              </div>
              <small class="text-muted-color">
                <pfx-icon-with-text
                  class="no-spacing"
                  [icon]="icons.signature"
                  >{{ caregiverData.lastDocumentationDate | date: 'dd.MM.yyyy' }}</pfx-icon-with-text
                >
              </small>
            </div>
          </div>
          <span class="p-1 ml-auto text-sm font-medium">{{ caregiverData.documentationCount }}</span>
        </li>
      } @empty {
        <li class="flex items-center">Keine Helfer gefunden</li>
      }
    </ul>
  }
</pfx-panel>
